import OnboardStep2Table from './OnboardStep2Table';

export default OnboardStep2Table;
